<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    <p>
      <span>地址：杭州市西湖区西溪路527号浙商创投中心C座406室</span> 
    </p>
    <span>Tel：0571-87671357</span>
    <p>
      <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;margin-top: 20px;">
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#fff;">浙ICP备2024122743号-1</p>
      </a>
    </p>
    <p class="copy">Copyright Copyright © 2024 杭州元杰瑞智科技有限有限公司 版权所有</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 420px;
  height: 80px;
  margin: 10px auto;
}
.logo img{
  width: 100%;
  height: 100%;
}
.title {
  font-size: 15px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  /* margin: 10px 0; */
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  /* margin: 50px 0 10px; */
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
.end{
    width: 1920px;
    height: 100px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue